import axios from 'axios'

const buildSignupHeaders = ({ recaptchaToken, redirectTo, csrfToken }) => {
  const headers = {
    'X-CSRF-TOKEN': csrfToken
  }

  if (redirectTo) {
    headers['Redirect-URL'] = redirectTo
  }

  if (recaptchaToken) {
    headers['G-Recaptcha'] = recaptchaToken
  }

  return headers
}

export const signup = async ({
  data,
  redirectTo,
  recaptchaToken,
  csrfToken
}) => {
  const response = await axios
    .post('/api/boitata/v1/signup', data, {
      headers: buildSignupHeaders({ recaptchaToken, redirectTo, csrfToken })
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const signupCompany = async ({ data, recaptchaToken, csrfToken }) => {
  const response = await axios
    .post('/api/boitata/v1/company/signup', data, {
      headers: buildSignupHeaders({ recaptchaToken, csrfToken })
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
